import { ManageRolesFormType } from "PFApp/types/activity_form/manage_roles_form_schema";

import { UnsavedEdit } from "./manage_roles_store.types";

export const isUnresolvedEdit = (edit: UnsavedEdit, newDraftRoles: ManageRolesFormType[]): boolean =>
  edit.status !== "failed" || newDraftRoles.some((role) => role.uniqueId === edit.roleId);
